import classNames from "./RadixDialog.module.css";
import * as Dialog from "@radix-ui/react-dialog";
import { ReactNode } from "react";
import { IoClose } from "react-icons/io5";

// TODO: Rename to just Dialog once all converted
export default function RadixDialog(props: {
  trigger?: ReactNode | ReactNode[];
  title: ReactNode | ReactNode[];
  content: ReactNode | ReactNode[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  unclosable?: boolean;
  contentClassName?: string;
  titleClassName?: string;
}) {
  return (
    <Dialog.Root open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Trigger asChild>{props.trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={classNames.DialogOverlay} />
        <Dialog.Content
          className={`${classNames.DialogContent} ${
            props.contentClassName ?? ""
          }`}
        >
          <Dialog.Title
            className={`${classNames.DialogTitle} ${
              props.titleClassName ?? ""
            }`}
          >
            {props.title}
            {!props.unclosable && (
              <Dialog.Close className={classNames.Close}>
                <IoClose />
              </Dialog.Close>
            )}
          </Dialog.Title>
          <div className={props.className}>{props.content}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
